// src/components/Footer.js
import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TikTokIcon from './TikTokIcon';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#000', boxShadow: '0 -3px 5px rgba(0,0,0,0.5)', py: 2 }}>
      <Container
        maxWidth="lg"
        sx={{
          display: { xs: 'block', sm: 'grid' },
          gridTemplateColumns: '1fr 1fr 1fr',
          alignItems: 'center',
          gap: 2,
          minHeight: '64px',
        }}
      >
        {/* Left Section: Logo for desktop */}
        <Box sx={{ display: { xs: 'none', sm: 'block' }, textAlign: 'left' }}>
          <Link to="/">
            <img src="/lfbbq.png" alt="Left Field BBQ logo" style={{ width: '200px' }} />
          </Link>
        </Box>
        {/* For mobile, optionally show a smaller, centered logo */}
        <Box sx={{ display: { xs: 'block', sm: 'none' }, textAlign: 'center', my: 1 }}>
          <Link to="/">
            <img src="/lfbbq.png" alt="Left Field BBQ logo" style={{ width: '150px' }} />
          </Link>
        </Box>
        {/* Center Section: Social Icons */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <IconButton href="https://instagram.com/leftfieldbbq/" aria-label="Follow us on Instagram" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
            <InstagramIcon sx={{ fontSize: 32 }} />
          </IconButton>
          <IconButton href="https://www.facebook.com/LeftFieldBBQ/" aria-label="Follow us on Facebook" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
            <FacebookIcon sx={{ fontSize: 32 }} />
          </IconButton>
          <IconButton href="https://tiktok.com/@leftfieldbbqllc/" aria-label="Follow us on TikTok" target="_blank" rel="noopener noreferrer" sx={{ color: '#fff' }}>
            <TikTokIcon sx={{ fontSize: 32 }} />
          </IconButton>
        </Box>
        {/* Right Section: Copyright text right aligned */}
        <Box sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
          <Typography variant="body2" sx={{ fontFamily: 'Roboto, sans-serif', color:'#fff' }}>
            © {new Date().getFullYear()} Left Field BBQ
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'Roboto, sans-serif', color:'#fff' }}>
            All rights reserved
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
